import { Platform } from "react-native";

const Fonts = {
  montserrat: {
    regular: {
      fontFamily: "Montserrat-Medium",
    },
    semiBold: {
      ...Platform.select({
        ios: {
          fontFamily: "Montserrat",
          fontWeight: "500" as "500",
        },
        android: {
          fontFamily: "Montserrat-SemiBold",
          fontWeight: "500" as "500",
        },
      }),
    },
    bold: {
      ...Platform.select({
        ios: {
          fontFamily: "Montserrat",
          fontWeight: "bold" as "bold",
        },
        android: {
          fontFamily: "Montserrat-Bold",
          fontWeight: "600" as "600",
        },
      }),
    },
  },
  inter: {
    regular: {
      fontFamily: "Iter-Regular",
    },
    medium: {
      ...Platform.select({
        ios: {
          fontFamily: "Iter",
          fontWeight: "500",
        },
        android: {
          fontFamily: "Iter-Medium",
        },
      }),
    },
    semiBold: {
      ...Platform.select({
        ios: {
          fontFamily: "Iter",
          fontWeight: "500",
        },
        android: {
          fontFamily: "Iter-SemiBold",
        },
      }),
    },
    bold: {
      ...Platform.select({
        ios: {
          fontFamily: "Iter",
          fontWeight: "bold",
        },
        android: {
          fontFamily: "Iter-Bold",
          fontWeight: "600",
        },
      }),
    },
  },
};

export const FontSize = {
  xs: { fontSize: 8 },
  s: { fontSize: 10 },
  sm: { fontSize: 12 },
  m: { fontSize: 14 },
  xm: { fontSize: 16 },
  sl: { fontSize: 18 },
  l: { fontSize: 20 },
  xl: { fontSize: 22 },
  xxl: { fontSize: 28 },
};

export default Fonts;
